import type { CheckinUserState } from './checkinActivity';

export const isParticipant = (
	userState: CheckinUserState,
): userState is Extract<CheckinUserState, { role: 'host' | 'participant' }> => {
	return ['host', 'participant'].includes(userState.role);
};
